import { Fragment } from 'react';


function Page(props) {
  const { children } = props;
  return <Fragment>{children}</Fragment>;
}


Page.displayName = 'Page';
export default Page;
